import React from 'react';
import autobind from 'autobind';
import { observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';

import { ContactPersonData } from 'chaika-frontend-types/frontend-cms';

import { ContactPersonForm } from '@profile/store/ContactPersonForm';

import { ContactPersonCard, ContactPersonCardParams } from './ContactPersonCard';

interface Props extends ContactPersonCardParams {
    onCancelClick(): void;
    onAddContactPerson(params: ContactPersonData): void;
}

@observer
export class AddContactPersonCardContainer extends React.Component<Props> {
    @observable
    private contactPerson: ContactPersonForm = new ContactPersonForm({
        firstName: '',
        lastName: '',
        patronymic: '',
        phone: '',
    });

    @observable
    private showValidStatus = false;

    constructor(props: Props) {
        super(props);
        makeObservable(this);
    }

    public render(): React.ReactNode {
        return React.createElement(ContactPersonCard, {
            isNew: true,
            firstName: this.contactPerson.firstName,
            isFirstNameValid: !this.showValidStatus || this.contactPerson.isFieldValid('firstName'),
            lastName: this.contactPerson.lastName,
            isLastNameValid: !this.showValidStatus || this.contactPerson.isFieldValid('lastName'),
            patronymic: this.contactPerson.patronymic,
            isPatronymicValid: !this.showValidStatus || this.contactPerson.isFieldValid('patronymic'),
            phone: this.contactPerson.phone,
            isPhoneValid: !this.showValidStatus || this.contactPerson.isFieldValid('phone'),
            onInputBlur: this.handleInputBlur,
            onInputChange: this.handleInputChange,
            onRemoveClick: this.handleCancelClick,
            onCountryChange: this.handleCountryChange,
        });
    }

    @autobind
    protected async handleInputBlur({ target: { name, value } }: React.FocusEvent<HTMLInputElement>) {
        await this.updateFieldValue(name, value);
    }

    @autobind
    protected handleInputChange(value: string, name: string) {
        this.contactPerson.setFieldValue(name, value);
        this.showValidStatus = true;
    }

    @autobind
    protected async handleCountryChange(newPhone: string) {
        await this.updateFieldValue('phone', newPhone);
    }

    @autobind
    protected handleCancelClick() {
        this.props.onCancelClick();
    }

    private async updateFieldValue(name: string, value: string): Promise<void> {
        const { onAddContactPerson } = this.props;

        this.contactPerson.setFieldValue(name, value);

        if (this.contactPerson.isFormValid) {
            await onAddContactPerson(this.contactPerson.serialize());
        }
    }
}
